import SearchPageSubmitCheckboxes from './searchPageSubmitCheckboxes';

const searchPageSubmitCheckboxesConfig = {
  name: 'SearchPageSubmitCheckboxes',
  class: SearchPageSubmitCheckboxes,
  querySelector: {
    form: '#search-aggregations-controls',
  },
  querySelectorAll: {
    controller: '.option-checkbox',
  },
};

export default searchPageSubmitCheckboxesConfig;
